import { ReactNode, forwardRef } from 'react';
import { ModuleSpacing } from '~/lib/data-contract';
import styles from './container.module.css';
import clsx from 'clsx';

type Breaks = 'small' | 'medium' | 'large';

export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
    spacingTop?: ModuleSpacing['spacingTop'];
    spacingBottom?: ModuleSpacing['spacingBottom'];
    hasGutter?: boolean | Breaks;
    children: ReactNode;
    hideMobile?: boolean;
    hideDesktop?: boolean;
    className?: string;
    fullWidth?: boolean;
};

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
    (
        {
            children,
            hasGutter,
            spacingTop,
            spacingBottom,
            hideMobile,
            hideDesktop,
            className,
            fullWidth = false,
            ...rest
        },
        ref
    ) => {
        return (
            <div
                ref={ref}
                className={clsx(styles.root, className, {
                    [styles.hasGutter]: hasGutter === true,
                    [styles[`gutterFrom-${hasGutter}`]]: typeof hasGutter === 'string',
                    [styles[`spacingTop-${spacingTop}`]]: spacingTop,
                    [styles[`spacingBottom-${spacingBottom}`]]: spacingBottom,
                    [styles.hideMobile]: hideMobile,
                    [styles.hideDesktop]: hideDesktop,
                    [styles.maxWidth]: !fullWidth,
                })}
                {...rest}
            >
                {children}
            </div>
        );
    }
);
Container.displayName = 'Container';
